import { render } from "./RequiredDocumentation.vue?vue&type=template&id=1480db1d&scoped=true"
import script from "./RequiredDocumentation.vue?vue&type=script&lang=js"
export * from "./RequiredDocumentation.vue?vue&type=script&lang=js"

import "./RequiredDocumentation.vue?vue&type=style&index=0&id=1480db1d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1480db1d"]])

export default __exports__